module.exports = __webpack_public_path__ + "img/[吃瓜].992c77ec.svg";